<template>
	<div class="menu">
		<button class="openMenu" @click.prevent="handleMenu">
			<i class="fas fa-bars"></i>
		</button>
		<nav class="mainNav" :class="{ show: isOpen }">
			<span class="closeMenu">
				<button @click.prevent="handleMenu">
					<span class="fas fa-times"></span>
				</button>
			</span>
			<ul @click.prevent="handleMenu">
				<li>
					<router-link to="/">Home</router-link>
				</li>
				<li v-for="categoria in categorias" :key="categoria.id">
					<router-link :to="`/duvidas/${categoria.slug}`">{{ categoria.nome }}</router-link>
				</li>
			</ul>
		</nav>
		<div class="overlayMenu" @click.prevent="handleMenu" :class="{ show: isOpen }"></div>
	</div>
</template>

<script>
export default {
	name: 'mainNav',
	data() {
		return {
			isOpen: false,
		};
	},
	methods: {
		handleMenu() {
			this.isOpen = !this.isOpen;
		},
	},
	computed: {
		categorias() {
			return this.$store.getters.categorias;
		},
	},
};
</script>

<style lang="scss">
@import './../assets/sass/menu';
</style>
